export default {
  name: 'BSC',
  chainIds: [56],
  rpcUrls: ['https://bsc-dataseed.binance.org'],
};
